// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { EventEmitter, OnInit } from '@angular/core';
import { GoAction, RolesService } from '@app/core';
import { AlertService } from '@app/core/services/alert.service';
import { Store } from '@ngrx/store';
import { BehaviorSubject, concat, of, Subject, zip } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
var ProjectCommitteeHandlerComponent = /** @class */ (function () {
    function ProjectCommitteeHandlerComponent(rolesService, alertService, store) {
        this.rolesService = rolesService;
        this.alertService = alertService;
        this.store = store;
        this.usernames = [];
        this.roleId = '';
        this.backTo = [];
        this.saved = new EventEmitter();
        this.projects$ = of([]);
        this.projectLoading = false;
        this.projectInput$ = new Subject();
        this.selectedProject$ = new BehaviorSubject(null);
        this.committees = [];
        this.committees$ = of([]);
        this.selectedCommittees = [];
        this.CommitteesPlaceholder = 'Select Committees';
        this.addRoleLoading = false;
    }
    ProjectCommitteeHandlerComponent.prototype.ngOnInit = function () {
        this.loadProjects();
        this.loadCommittees();
    };
    ProjectCommitteeHandlerComponent.prototype.trackByFn = function (item) {
        return item.id;
    };
    ProjectCommitteeHandlerComponent.prototype.loadProjects = function () {
        var _this = this;
        this.projects$ = concat(of([]), this.projectInput$.pipe(distinctUntilChanged(), tap(function () { return (_this.projectLoading = true); }), switchMap(function (term) {
            return _this.rolesService
                .getProjects({
                search: term
            })
                .pipe(catchError(function () { return of([]); }), tap(function () { return (_this.projectLoading = false); }), tap(function () { return (_this.selectedCommittees = []); }));
        })));
    };
    ProjectCommitteeHandlerComponent.prototype.loadCommittees = function () {
        var _this = this;
        this.committees$ = this.selectedProject$.pipe(switchMap(function (project) {
            if (!project || !project.id) {
                return of([]);
            }
            return _this.rolesService.getProjectScopes({
                projectId: project.id
            });
        }), map(function (scopes) {
            if (!scopes || !scopes.length) {
                _this.CommitteesPlaceholder = 'No Committees found';
                return [];
            }
            else {
                _this.CommitteesPlaceholder = 'Select Committees';
            }
            return scopes.map(function (scope) {
                return {
                    id: scope.id,
                    name: scope.name
                };
            });
        }));
    };
    ProjectCommitteeHandlerComponent.prototype.save = function () {
        var _this = this;
        if (this.selectedCommittees.length === 0) {
            this.alertService.error('Please select at least one committee');
            return;
        }
        if (this.addRoleLoading) {
            this.alertService.error('Please wait for the current operation to complete');
            return;
        }
        zip(this.selectedProject$, of(this.selectedCommittees)).subscribe(function (_a) {
            var project = _a[0], committees = _a[1];
            console.log('saved', { project: project, committees: committees });
            var projectId = project.id;
            var committeeIds = committees.map(function (c) { return c.id; });
            _this.rolesService
                .createRoleMeetingCommittees({
                roleId: _this.roleId,
                usernames: _this.usernames,
                projectId: projectId,
                committeeIds: committeeIds
            })
                .pipe(tap(function () { return (_this.addRoleLoading = true); }), catchError(function (err) {
                _this.alertService.error(err.error.message);
                throw err;
            }), tap(function () { return (_this.addRoleLoading = false); }))
                .subscribe(function (response) {
                console.log('saved', response);
                _this.alertService.success('Role scope saved successfully');
                _this.saved.emit(true);
                _this.backToPreviousPage();
            });
        });
    };
    ProjectCommitteeHandlerComponent.prototype.cancel = function () {
        this.backToPreviousPage();
        this.saved.emit(false);
    };
    ProjectCommitteeHandlerComponent.prototype.backToPreviousPage = function () {
        if (this.backTo.length) {
            this.store.dispatch(new GoAction(this.backTo));
        }
    };
    return ProjectCommitteeHandlerComponent;
}());
export { ProjectCommitteeHandlerComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/project-comittee-handler/project-comittee-handler.component.ts.pre-build-optimizer.js